import { Button, Form, Grid } from 'antd';
import { Modal } from 'components';
import { useCreateSelectCompany } from 'features/Dashboard/use-cases/select-company';
import { useUserContext } from 'features/users';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
import { UserFormValues } from 'features/users/components/users-filter-form';
import { User } from 'lucide-react';
import { useState } from 'react';

const { useBreakpoint } = Grid;

export const ChangeComapnyItemModal = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const formName = 'add-user-form';
  const screens = useBreakpoint();
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<UserFormValues>();
  const { companyUser, user } = useUserContext();
  const { mutate } = useCreateSelectCompany();

  // Track loading state for each company by CompanyId
  const [loadingCompanyIds, setLoadingCompanyIds] = useState<{
    [key: string]: boolean;
  }>({});

  const handleSubmit = (value: any) => {
    const payload: any = {
      companyId: value?.CompanyId,
      clientId: value?.Id,
    };

    // Set loading state for this company
    setLoadingCompanyIds((prevState) => ({
      ...prevState,
      [value?.CompanyId]: true,
    }));

    mutate(payload, {
      onSuccess: (data: any) => {
        if (data?.rs === 1) {
          // Reset loading state once the request succeeds
          setLoadingCompanyIds((prevState) => ({
            ...prevState,
            [value?.CompanyId]: false,
          }));
          window.location.reload(); // Reload the page
        }
      },
      onError: () => {
        // Reset loading state on error
        setLoadingCompanyIds((prevState) => ({
          ...prevState,
          [value?.CompanyId]: false,
        }));
      },
    });
  };

  return (
    <StyledUserModalWrapper>
      <Modal
        className='cstm_centermodal'
        open
        centered
        title={'Change Company'}
        onCancel={onClose}
        getContainer={false}
        onOk={form.submit}
        okText={'Save'}
        footer={null}
        cancelButtonProps={{ style: { display: 'none' } }}
        width={screens.lg ? '425px' : '100%'}
        okButtonProps={{
          form: formName,
        }}
        maskClosable={false}
      >
        <Form<UserFormValues>
          id={formName}
          name={formName}
          form={form}
          layout='vertical'
          onFinishFailed={() => {
            setValidateTrigger(['onChange']);
          }}
          validateTrigger={validateTrigger}
        >
          <div className='cnglist'>
            {companyUser?.rc?.map((item: any, index: number) => (
              <div className='crd_rptr' key={index}>
                <div
                  className='crd_bx'
                  style={{
                    border: item.IsDefault
                      ? '1px solid #223666'
                      : '1px solid #f0f0f0',
                    boxShadow: item.IsDefault
                      ? '0 4px 6px rgba(24, 144, 255, 0.2)'
                      : 'none',
                  }}
                >
                  <div className='media'>
                    {item?.CompanyImage ? (
                      <img src={item.CompanyImage} alt={item.BusinessName} />
                    ) : (
                      <User />
                    )}
                  </div>
                  <div
                    className='crd_vlu'
                    style={{ paddingRight: item.IsDefault ? '0px' : '60px' }}
                  >
                    <h3>
                      <span>Company Name:</span>
                      {item.BusinessName}
                    </h3>
                    <p>{item.Name}</p>
                    {item.CompanyId !== user?.CompanyId ? (
                      <div className='button-group'>
                        <Button
                          className='btn'
                          type='primary'
                          loading={loadingCompanyIds[item.CompanyId] || false} // Show loader for the specific company
                          onClick={() => handleSubmit(item)}
                        >
                          Change
                        </Button>
                      </div>
                    ) : (
                      <div className='button-group' style={{ bottom: 'unset' }}>
                        <span
                          style={{
                            color: '#155724',
                            background: '#d4edda',
                            border: '#c3e6cb',
                            fontSize: '12px',
                            padding: '3px 10px',
                            borderRadius: '5px',
                          }}
                        >
                          Active
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Form>
      </Modal>
    </StyledUserModalWrapper>
  );
};
